<form
  [formGroup]="responsivenessFormGroup"
  (change)="handleChange('responsiveness')"
>
  <div class="group">
    <div class="header" translate="responsiveness"></div>
    <p
      class="description"
      [innerHTML]="'responsivenessDescription' | translate"
    ></p>
    <label>
      <input
        type="radio"
        name="responsiveness"
        [value]="true"
        formControlName="responsiveness"
      />
      <span class="img"></span>
      <span class="text" translate="on"></span>
    </label>
    <label>
      <input
        type="radio"
        name="responsiveness"
        [value]="false"
        formControlName="responsiveness"
      />
      <span class="img"></span>
      <span class="text" translate="off"></span>
    </label>
  </div>
</form>
